import './styles/theme.css';
import { ThemeProvider } from './context/ThemeContext';
import { HomeGradientBackground } from './components/HomeGradientBackground';
import { HomeScreen } from './screens/HomeScreen';

function App() {
  return (
    <ThemeProvider>
      <HomeGradientBackground>
        <HomeScreen />
      </HomeGradientBackground>
    </ThemeProvider>
  );
}

export default App;
